export default {

  methods: {

    set_LocalValues(){

      this.tblData = JSON.parse(JSON.stringify(this.DataItems))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.title    = json.title
      this.header   = json.header
      this.table    = json.table
      this.columns  = json.columns
      this.keys     = json.keys
      this.filters  = json.filters
      this.sundries = json.sundries

      this.gmx_tableCoordinates('x', this.columns, 5)
      this.table.width = this.columns[this.columns.length-1].ex
      this.table.height = this.header.height + this.tblData.length * this.table.lineHeight


      console.log(this.table.width)
    },

  }
}